import { Link, NavLink } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useCart } from '../context/CartContext';
import { CurrencySwitcher } from './CurrencySwitcher';

const links = [
  { to: '/shop', label: 'Shop' },
  { to: '/quiz', label: 'Skin Quiz' },
  { to: '/about', label: 'About' },
];

export const Navbar = () => {
  const { itemCount, setDrawerOpen } = useCart();
  const [mobile, setMobile] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-lum-bg/80 border-b border-lum-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <button data-testid="mobile-menu-toggle" className="md:hidden" onClick={() => setMobile(true)} aria-label="open menu">
          <Menu size={20} />
        </button>

        <nav className="hidden md:flex items-center gap-10 flex-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(' ', '-')}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.22em] font-medium transition-colors ${isActive ? 'text-lum-text' : 'text-lum-text2 hover:text-lum-text'}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/" data-testid="logo-link" className="flex-1 text-center">
          <span className="font-serif-display text-3xl tracking-tight">Lumière</span>
          <span className="block text-[10px] uppercase tracking-[0.35em] -mt-1 text-lum-text2">Skin</span>
        </Link>

        <div className="flex-1 flex justify-end items-center gap-5">
          <div className="hidden sm:block">
            <CurrencySwitcher compact />
          </div>
          <button
            data-testid="open-cart-button"
            onClick={() => setDrawerOpen(true)}
            className="relative flex items-center gap-2 text-xs uppercase tracking-[0.22em]"
          >
            <ShoppingBag size={18} strokeWidth={1.4} />
            <span className="hidden sm:inline">Cart</span>
            <span data-testid="cart-count" className="ml-1 min-w-[20px] h-5 px-1.5 rounded-full bg-lum-text text-lum-bg text-[10px] flex items-center justify-center">
              {itemCount}
            </span>
          </button>
        </div>
      </div>

      {mobile && (
        <div className="fixed inset-0 z-50 bg-lum-bg md:hidden">
          <div className="flex items-center justify-between p-6 border-b border-lum-border">
            <span className="font-serif-display text-2xl">Lumière</span>
            <button onClick={() => setMobile(false)} aria-label="close"><X size={22} /></button>
          </div>
          <div className="flex flex-col p-6 gap-6">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setMobile(false)} className="text-2xl font-serif-display">
                {l.label}
              </NavLink>
            ))}
            <div className="pt-6 border-t border-lum-border">
              <p className="overline mb-3">Currency</p>
              <CurrencySwitcher />
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
